import {makeSystemModePath} from './shared/serverFunctions';

/**
 * VIP Trends
 *      All, Filters
 *      by: Location, Loyalty, DBA, District, State
 *      by: State & City, State & DBA
 */
export const RESOURCES = {
    "VIPTrendsCount": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/vipCountByLocationDateRange/" + startEndOffset
            }
        }
    },
    "VIPTrendsAll": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends (All)",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByDateRange/" + startEndOffset
            }
        }
    },
    "VIPTrendsByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by Location",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/vipTrendsReportByLocationDateRange/" + startEndOffset
            }
        }
    },
    "VIPTrendsByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByDBADateRange/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "VIPTrendsByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by District",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByDistrictDateRange/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "VIPTrendsByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByStateDateRange/" + params.state + "/" + startEndOffset
            }
        }
    },
    "VIPTrendsByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by City and State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByCityStateDateRange/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "VIPTrendsByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by City and DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByStateDBADateRange/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "VIPTrendsByLoyalty": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends by Loyalty Account",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsReportByLoyaltyDateRange/" + params.loyalty_id + "/" + startEndOffset
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "VIPTrendsByState"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseVIPTrendsReportsResourceMap.js